import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

import { customTooltipHandler } from "..";
import styles from "../statistics.module.css";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

export function ProjectRisk({ projectRisk }) {
  const total = projectRisk?.total;

  const centerTextPlugin = {
    id: "centerText",
    afterDraw(chart, args, options) {
      const { ctx, chartArea } = chart;
      const { width, height } = chartArea;

      const total = options.total;
      if (!total) return;

      ctx.save();
      ctx.font = "bold 28px Arial";
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(total, width / 2, height / 2);
      ctx.restore();
    },
  };

  const labels = ["High", "Medium", "Low"];
  const dataValues = [
    projectRisk?.high?.percent,
    projectRisk?.medium?.percent,
    projectRisk?.low?.percent,
  ];
  const valueValues = [
    projectRisk?.high?.value,
    projectRisk?.medium?.value,
    projectRisk?.low?.value,
  ];
  const data = {
    labels,
    datasets: [
      {
        label: "Project Risk",
        data: dataValues,
        backgroundColor: ["#F27281", "#F5B452", "#4DC7B5"],
        borderColor: "#fff",
        borderWidth: 2,
        hoverOffset: 4,
        borderRadius: 6,
      },
    ],
  };
  const slicePercentPlugin = {
    id: "slicePercent",
    afterDraw(chart) {
      const { ctx, data } = chart;
      const dataset = data.datasets[0];
      const total = dataset.data.reduce((acc, val) => acc + val, 0);

      ctx.save();
      ctx.font = "500 14px Arial";
      ctx.fillStyle = "#ffffffff";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const meta = chart.getDatasetMeta(0);
      meta.data.forEach((arc, index) => {
        const value = dataset.data[index];
        if (!value) return;

        const percent = total ? ((value / total) * 100).toFixed(0) : 0;
        if (percent === "0") return;

        const { x, y } = arc.getCenterPoint();
        ctx.fillText(`${percent}%`, x, y);
      });

      ctx.restore();
    },
  };

  const options = {
    responsive: true,
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          color: "#374151",
          font: { size: 14 },
        },
      },
      tooltip: {
        enabled: false,
        external: (context) => {
          const index = context.tooltip?.dataPoints?.[0]?.dataIndex;
          if (index === undefined) return;

          const value = valueValues[index];
          customTooltipHandler(context, value);
        },
      },
      title: {
        display: false,
      },
      centerText: {
        total: total?.toString().substring(0, 3),
      },
    },
  };

  return (
    <div className={styles.statisticsContent} style={{ margin: "0 auto" }}>
      <h2 className={styles.statisticsTitle}>Project Risk</h2>
      <div
        className={styles.statisticsColoredBar}
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          width: "850px",
          marginTop: "50px",
        }}
      >
        <div
          className={styles.statisticTableWrapper}
          style={{
            marginTop: "10px",
            height: "300px",
            width: "450px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className={styles.statisticTableOneColumn}
            style={{
              width: "60%",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                background: "transparent",
                width: "140px",
                height: "140px",
                borderRadius: "135px",
                top: "65px",
                left: "65px",
                boxShadow: "0px 4.09px 19.11px 0px #00000029",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                background: "transparent",
                width: "155px",
                height: "155px",
                borderRadius: "155px",
                top: "57px",
                left: "57px",
                border: "1px dashed #8D8D8D",
              }}
            ></div>
            <Doughnut
              data={data}
              options={options}
              plugins={[centerTextPlugin, slicePercentPlugin]}
            />
          </div>
        </div>
      </div>
      <div className={styles.divider} style={{ marginTop: "-20px" }}></div>
      <div className={styles.legendWrapper}>
        <div className={styles.legend}>Legend</div>
        <div className={styles.legend}>
          <span className={styles.redColoresSquare}></span>High
        </div>
        <div className={styles.legend}>
          {" "}
          <span className={styles.yellowColoresSquare}></span>Medium
        </div>
        <div className={styles.legend}>
          {" "}
          <span className={styles.greenColoresSquare}></span>Low
        </div>
      </div>
    </div>
  );
}
